import { Brain, Camera, Dumbbell, Utensils, Refrigerator, MapPin, Footprints } from 'lucide-react';

export const APP_SCREENSHOTS = [
  // Iter229 (Feb 2026): reordered to Dashboard → Workout → Nutrition
  // → AI Planner & Analyzer → Walking → Supplements → Gym Finder per
  // user request. Also aligned every slot's `label` with the actual
  // desktop image content so mobile+desktop carousels no longer show
  // mismatched headings.
  {
    id: 'dashboard',
    label: 'Dashboard',
    description: 'Your fitness command center',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/1535dor6_Screenshot_2026-05-03-11-29-35-584_com.android.chrome.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/s5e084c4_Dashboard.png'
  },
  {
    id: 'training',
    label: 'Start Workout',
    description: 'Track every rep and set',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/cg1emldq_Start%20Workout.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/g6or0ww7_Workout.png'
  },
  {
    id: 'nutrition',
    label: 'Nutrition',
    description: 'AI meal tracking & macros',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/k3nef3lm_Nutrition.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/usx97tkq_Nutrition.png'
  },
  {
    id: 'ai-planner',
    label: 'AI Planner & Analyzer',
    description: 'Personalized routines + volume analysis',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/wo27d83g_AI%20Planner.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/lhzvi3i9_AI%20Planner%20%26%20Analyzer.webp'
  },
  {
    id: 'walking',
    label: 'Walking Tracker',
    description: 'Steps, calories & goals',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/44knh3mb_Walking.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/wh76na05_Walking.png'
  },
  {
    id: 'supplements',
    label: 'Supplements',
    description: 'Daily protocol & smart reminders',
    // Iter230 (Feb 2026): dedicated portrait screenshot for mobile
    // carousel (Kreatiin daily + push reminders card). Desktop keeps
    // the landscape Supplements.png.
    url: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/5n15l0zy_Screenshot_2026-07-25-15-13-58-186_com.android.chrome.webp',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/x8vl2f9p_Supplements.png'
  },
  {
    id: 'gym-finder',
    label: 'Gym Finder',
    description: 'Find gyms anywhere in the world',
    url: 'https://customer-assets.emergentagent.com/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/0lms1fos_Gym%20Finder.jpg',
    desktopUrl: 'https://customer-assets-agu9un31.emergentagent.net/job_7f122fb3-fb49-4dd0-b519-ce0b1a1860fb/artifacts/93xuwgvd_Gym%20Finder.png'
  }
];

export const FEATURES = [
  {
    icon: Brain,
    title: 'AI Workout Plan Generator',
    description: 'Get personalized gym routines created by AI based on your goals, equipment, and fitness level. Your personal AI coach.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-purple-400 to-purple-600 shadow-lg shadow-purple-500/50',
  },
  {
    icon: Camera,
    title: 'AI Calorie Counter from Photo',
    description: 'Snap a photo of your meal for instant calorie estimates. AI calorie counter from menu at restaurants.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-pink-400 to-pink-600 shadow-lg shadow-pink-500/50',
  },
  {
    icon: Dumbbell,
    title: 'Complete Gym Tracker',
    description: 'Log every rep, set, and weight. The best gym workout log app for tracking your strength training progress.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-green-400 to-emerald-600 shadow-lg shadow-green-500/50',
  },
  {
    icon: Utensils,
    title: 'AI Meal Planner & Nutrition',
    description: 'AI nutrition tracking with macro counting. Search 2.9M+ foods or scan barcodes. Your complete gym and nutrition app.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-orange-400 to-orange-600 shadow-lg shadow-orange-500/50',
  },
  {
    icon: Refrigerator,
    title: 'FridgeOracle AI Scanner',
    description: 'Snap a photo of your fridge and AI identifies all items, tracks freshness, suggests rescue recipes, and builds smart grocery lists.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-cyan-400 to-teal-600 shadow-lg shadow-cyan-500/50',
  },
  {
    icon: MapPin,
    title: 'Find Gym While Traveling',
    description: 'Never miss a workout! Find nearby gyms anywhere in the world. Perfect for gym goers who travel.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-cyan-400 to-cyan-600 shadow-lg shadow-cyan-500/50',
  },
  {
    icon: Footprints,
    title: 'Walking Workout Tracker',
    description: 'Track your walking workouts with GPS, steps, and calories. Interval walking programs for active and fit lifestyle.',
    color: 'text-white',
    bgColor: 'bg-gradient-to-br from-yellow-400 to-amber-600 shadow-lg shadow-yellow-500/50',
  }
];

export const HOW_IT_WORKS = [
  {
    step: '1',
    title: 'Set Your Fitness Goals',
    description: 'Tell our AI coach about your goals - build muscle, lose fat, or get stronger. Enter your stats and available equipment.'
  },
  {
    step: '2',
    title: 'Get Your AI Workout Plan',
    description: 'Our AI workout plan generator creates personalized gym routines tailored to your schedule and fitness level.'
  },
  {
    step: '3',
    title: 'Track Workouts & Nutrition',
    description: 'Log your gym workout, track nutrition with AI calorie counter from photo, and monitor your progress.'
  },
  {
    step: '4',
    title: 'See Real Results',
    description: 'Watch your strength increase, body transform, and fitness improve with detailed statistics and progress tracking.'
  }
];

export const AI_COACH_FEATURES = [
  'Personalized workout plans based on your goals',
  'AI calorie counter from photo & menu',
  'Smart exercise suggestions with alternatives',
  'Automatic progressive overload recommendations',
  'Meal suggestions based on your macros',
  'Rest timer with voice announcements'
];

export const FAQ_ITEMS = [
  {
    question: 'Is Fitness&me free?',
    answer: 'Yes. You get a 2-week free trial of every premium feature — AI workout planner, AI diet planner, AI plate/menu/barcode scanner, and body composition analysis. After the trial, the free tier (gym tracker, exercise catalog, walking timer, BMR/TDEE calculators) stays free forever. Premium is cancel-anytime with a 30-day money-back guarantee.'
  },
  {
    question: 'Can Fitness&me count calories from a photo?',
    answer: 'Yes. Snap a photo of your plate and our AI calorie counter identifies the foods, estimates portion sizes, and returns calories plus a full macro breakdown (protein, carbs, fat). It also reads restaurant menus, barcodes, and the inside of your fridge — Fridge Scan even suggests recipes from what you already have.'
  },
  {
    question: 'How accurate is AI body fat estimation from a photo?',
    answer: "Fat% AI gives you an estimate, not a measurement. A vision AI model (Gemini 3.1 Pro) reads your photo and combines it with distance-invariant body proportions measured on your own device, so camera distance doesn't skew the number. Use clear, well-lit photos and treat the result as a trend you re-run every few weeks — it is not a DEXA scan, a caliper reading, or a medical device."
  },
  {
    question: 'Does Fitness&me work offline?',
    answer: "Yes. Fitness&me is a Progressive Web App (PWA) with full offline support — you can log workouts, track meals, count walking steps, and view your plans without an internet connection. Your data syncs to the cloud as soon as you're back online, and a full cloud backup runs automatically every 6 hours."
  },
  {
    question: 'Can I use Fitness&me without going to a gym?',
    answer: 'Yes. The AI Workout Planner supports four equipment modes: Bodyweight only, Dumbbell only, Home Gym (multi-select barbell, dumbbells, kettlebell, bands, cables, pull-up bar, bench), and Full Gym. Every plan is built from a curated 870+ exercise catalog so each movement matches what you actually own.'
  },
  {
    question: 'How does the AI workout planner work?',
    answer: 'You answer a short onboarding (goals, experience, equipment, schedule, injuries). Claude Opus 4.7 then generates a weekly plan picking only from the curated exercise catalog, respecting your time budget and equipment. The plan adapts week-to-week based on what you actually lifted — using APRE 10 autoregulation to scale loads up or down.'
  },
  {
    question: 'Can I find a gym while traveling?',
    answer: "Absolutely. Gym Finder shows you nearby gyms anywhere in the world with Google ratings, opening hours, phone and website, whether they're open right now, plus a 24/7-access search filter. Your routine survives every business trip, holiday, or relocation — you'll never break your streak because of travel."
  },
  {
    question: 'What devices does Fitness&me work on?',
    answer: 'Fitness&me runs on any modern browser (Chrome, Safari, Firefox, Edge) and installs as a native-feeling app on iOS, Android, Windows, macOS, and ChromeOS via PWA. No separate App Store or Play Store download required — the install prompt appears automatically on supported devices.'
  },
  {
    question: 'How does the AI Analyzer count sets for MEV / MAV / MRV?',
    answer: 'Every logged working set contributes 1.0 to its primary muscle group and 0.5 to each secondary muscle (per Renaissance Periodization consensus). So one Bench Press set counts as 1.0 for Chest, 0.5 for Shoulders and 0.5 for Triceps. Warm-up sets (below 60% of that day\'s top weight on the same lift) are automatically excluded, half-rep sets count as 1.0 (partials are treated as sub-set effort within the same set), and sets marked skipped or explicitly un-done are dropped. The analysis window is the last N days ending YESTERDAY — today\'s partial-day logs are never counted so mid-day averages stay clean. Sets per week are normalized so 2-week, 1-month, 6-week and 3-month analyses stay directly comparable to the weekly MEV/MAV/MRV landmarks.'
  },
  {
    question: 'How does the AI Analyzer treat dropsets, myoreps, supersets and rest-pause sets?',
    answer: 'Dropsets: a working set plus all of its drop rows (drop 1, drop 2, drop 3…) still count as ONE set for volume math — a dropset is an intensifier, not a set multiplier (Israetel, Stronger By Science). Supersets (two different lifts alternating): each exercise contributes its own volume with no discount and no double-count, so a Bench × Row superset for 3 rounds adds 3.0 to Chest AND 3.0 to Back. Combo Sets / rest-pause / clusters (two linked sets of the same lift): both count as separate working sets — precise for clusters, slightly generous for a strict rest-pause (RP considers rest-pause ~1.5 effective sets). Myoreps are not yet a distinct set type — if you log the activation set plus mini-sets as separate sets they each count as a full set (slight over-count). Log the whole myorep cluster as a single set with a note to keep the volume math tight.'
  }
];
